export default __webpack_public_path__ + "images/a8f2f4389259169fe89ed88899f9a51a.svg";